import { H3 } from 'UIComponents/elements/headings';
import { useSelector } from 'react-redux';
import { Step } from 'signup-constants/Step';
import HubletExpandableSubTitleSection from '../../hublets/HubletExpandableSubTitleSection';
import { getCurrentStep } from '../../store/flow/selectors';
import { getActiveLoading } from '../../store/loading-status/selectors';
import { getStepTitle } from '../../utils/getStepTitle';
import { OptionalFormattedMessage } from '../../views-components/OptionalFormattedMessage';
import { CodeVerificationEmailHelper } from '../../step-code-verification/CodeVerificationView';
import { getLandingPageTitle } from '../../step-landing-page/getLandingPageText';
import { useResponsiveness } from '../../responsiveness/ResponsivenessProvider';
import { getFlowKey } from '../../routing/getFlowKey';
import { CarouselTitle } from '../../step-landing-page/CarouselTitle';
import { LandingPageSubtitle } from '../../step-landing-page/LandingPageTitle';
import { TrackWhen, useExperiment } from '../useExperiment';
import { ExperimentKeys } from '../ExperimentKeys';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useName } from '../../hooks/useName';
import { AnimatedStep } from 'signup-components/styles/Animations.styles';
import { ACQ0143HelperText } from './ACQ0143HelperText';
import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
import { getSignupDataPrefilled } from '../../store/signup-data/selectors';
import { getStepData } from '../../step/getStepData';
import { ACQ0143Title } from './ACQ0143Title';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledH3 = styled(H3).withConfig({
  displayName: "ACQ0143TitleContainer__StyledH3",
  componentId: "sc-1w2fjxn-0"
})(["font-size:26px;"]);
const DesktopWidthWrapper = styled.div.withConfig({
  displayName: "ACQ0143TitleContainer__DesktopWidthWrapper",
  componentId: "sc-1w2fjxn-1"
})(["@media ", "{width:515px;}margin-bottom:32px;"], devices.desktop);
const HelperTextWrapper = styled.div.withConfig({
  displayName: "ACQ0143TitleContainer__HelperTextWrapper",
  componentId: "sc-1w2fjxn-2"
})(["@media ", "{max-width:800px;}"], devices.desktop);
export const ACQ0143TitleContainer = () => {
  const flowKey = getFlowKey();
  const stepKey = useSelector(getCurrentStep);
  const stepDataKeys = stepKey ? getStepData(stepKey) : [];
  const stepTitle = useSelector(getStepTitle);
  const {
    isAssignedToVariant: isACQ0143Variant
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.never);
  const isStepDataPrefilled = useSelector(state => {
    return stepDataKeys.every(dataKey => getSignupDataPrefilled(state, dataKey));
  });
  const activeLoading = useSelector(getActiveLoading);
  const {
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    name
  } = useName();
  const getLandingPageSubtitle = () => {
    const landingPagedefaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
    return isMobile ? landingPagedefaultMobileSubtitle : subtitleLabel;
  };
  if (isACQ0143Variant() && !activeLoading) {
    if (stepKey === Step.LandingPage) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CarouselTitle, {}), /*#__PURE__*/_jsx(LandingPageSubtitle, {
          children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
            message: getLandingPageSubtitle()
          })
        })]
      });
    }
    if (stepKey === Step.WhatsNext) {
      return /*#__PURE__*/_jsx(AnimatedStep, {
        animationDelay: false,
        disableAnimation: false,
        children: /*#__PURE__*/_jsx(StyledH3, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: stepTitle,
            options: {
              name
            }
          })
        })
      }, stepKey);
    }
    return /*#__PURE__*/_jsxs(AnimatedStep, {
      animationDelay: false,
      disableAnimation: false,
      children: [/*#__PURE__*/_jsx(ACQ0143Title, {
        isStepDataPrefilled: isStepDataPrefilled,
        stepKey: stepKey,
        stepTitle: stepTitle
      }), stepKey === Step.HubletSelection && /*#__PURE__*/_jsx(DesktopWidthWrapper, {
        children: /*#__PURE__*/_jsx(HubletExpandableSubTitleSection, {
          titleKey: `views.${Step.HubletSelection}.expandableSubTitleSection.acq143Title`
        })
      }), stepKey === Step.CodeVerification && /*#__PURE__*/_jsx(CodeVerificationEmailHelper, {}), /*#__PURE__*/_jsx(HelperTextWrapper, {
        children: /*#__PURE__*/_jsx(ACQ0143HelperText, {
          isStepDataPrefilled: isStepDataPrefilled
        })
      })]
    }, stepKey);
  }
  return null;
};